var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockOpenDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 6.66675C9.11523 6.66675 8.273 6.84248 7.49976 7.15601V4.16675C7.49976 2.78647 8.61948 1.66675 9.99976 1.66675C11.3808 1.66675 12.4998 2.78647 12.4998 4.16675V5H14.1665V4.16675C14.1665 1.86523 12.3013 0 9.99976 0C7.69824 0 5.83301 1.86523 5.83301 4.16675V8.13325C4.3105 9.35552 3.33301 11.229 3.33301 13.3335C3.33301 17.015 6.31802 20 9.99976 20C13.6815 20 16.6665 17.015 16.6665 13.3335C16.6665 9.65176 13.6815 6.66675 9.99976 6.66675ZM9.99976 18.3333C7.24277 18.3333 4.99976 16.0905 4.99976 13.3335C4.99976 10.5763 7.24277 8.3335 9.99976 8.3335C12.7567 8.3335 14.9998 10.5763 14.9998 13.3335C14.9998 16.0905 12.7567 18.3333 9.99976 18.3333Z",
    fill: "#7A297F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 10.8334C9.07925 10.8334 8.33301 11.5804 8.33301 12.4999C8.33301 13.1151 8.67002 13.6474 9.1665 13.9354V15.8331H10.833V13.9354C11.3295 13.6474 11.6665 13.1151 11.6665 12.4999C11.6665 11.5804 10.9203 10.8334 9.99976 10.8334Z",
    fill: "#7A297F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenDark);
export default __webpack_public_path__ + "static/media/lock-open-dark.c3c5cc0fe8ee716e0a83f68509bfa5a6.svg";
export { ForwardRef as ReactComponent };